import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SubscriptionStatusService } from '../services/subscription-status.service';
import { ToastService } from '../services/toast.service';

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
    const router = inject(Router);
    const subscriptionStatus = inject(SubscriptionStatusService);
    const toast = inject(ToastService);

    return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
            // Trial / subscription expired — the backend guard returns 402 with a machine-readable body.
            if (error.status === 402 && error.error?.errorCode === 'SUBSCRIPTION_EXPIRED') {
                subscriptionStatus.markExpired(error.error);
                toast.warn(error.error.message ?? 'Your subscription has expired.', 'Subscription required');
                if (!router.url.startsWith('/billing')) {
                    router.navigate(['/billing']);
                }
                return throwError(() => error);
            }

            let errorMessage = 'An unknown error occurred!';

            if (error.error instanceof ErrorEvent) {
                // Client-side error
                errorMessage = error.error.message;
            } else {
                // Server-side error
                errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
            }

            // Here you could add a call to a notification service to show the error
            console.error(' error : ', errorMessage);
            return throwError(() => new Error(errorMessage));
        })
    );
};
